// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type ElementFragment = { __typename?: 'ElementDTO', amount: number, description: string, id: string, quantity: number | null, vat: number | null };

export const ElementFragment = gql`
    fragment Element on ElementDTO {
  amount
  description
  id
  quantity
  vat
}
    `;
/* eslint-enable */